import * as _4 from 'lodash4';

import { IContentTileActionObj } from 'ui-ng-content-tile';
import { Hold } from '../builders/holds_builder';
import { HoldsConfigService } from './holds_config_servant';

export class HoldsAttentionServant {
  static isRegistrationHold(hold: Hold): boolean {
    return hold.is_registration_hold && hold.send_notifications;
  }

  static HasHoldType(hold: Hold): boolean {
    return !!_4.get(hold, 'hold_type_id', false);
  }

  static isHoldThatRequiresAttention(hold: Hold): boolean {
    return (
      HoldsAttentionServant.HasHoldType(hold) &&
      HoldsAttentionServant.isRegistrationHold(hold) &&
      !HoldsAttentionServant.isPastHold(hold)
    );
  }

  static isRegularHold(hold: Hold): boolean {
    return (
      HoldsAttentionServant.HasHoldType(hold) &&
      !HoldsAttentionServant.isRegistrationHold(hold) &&
      !HoldsAttentionServant.isPastHold(hold)
    );
  }

  static isPastHold(hold: Hold): boolean {
    return moment().isAfter(hold.end_dt);
  }

  static getHoldRoutingDetails(hold: Hold, config: HoldsConfigService): IContentTileActionObj {
    return {
      state: config.detailRoute,
      params: {
        holdTypeId: _4.get(hold as object, 'hold_type_id'),
        id: _4.get(hold as object, 'id'),
        additionalInfo: {
          amountOwed: _4.get(hold as object, 'amount'),
          reason: _4.get(hold as object, 'reason_text'),
          description: _4.get(hold as object, 'desc')
        }
      }
    };
  }

  static getHoldIcon(hold: Hold) {
    const type = this.isHoldThatRequiresAttention(hold) ? 'warning_filled' : 'warning';
    const theme = 'orange';
    return { type, theme };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/servants/holds_attention_servant.ts